import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	width: 100%;

	.form {
		width: 100%;
		margin: 2em 0;
		display: flex;
		flex-flow: column wrap;
		place-items: center;

		.form-input-row {
			flex-flow: column wrap;
			max-width: 35%;
			gap: 0.5em;
		}

		.submit-button {
			margin: 2em 0;
			justify-content: flex-start;
		}

		.button-password-visible {
			.button {
				padding: 0;
				max-height: 2.8em;
				background-color: transparent;
				border: 0;
			}

			.button-icon-wrapper {
				padding: 0 0.1em;
				margin: 0.2em 0 0 0;

				.icon {
					padding: 0 0.2em;
				}
			}
		}

		.google {
			min-width: 35%;
			width: 35%;

			.google-binded {
				margin: 1em 0 1.5em 0;
				min-width: 100%;

				.headline {
					margin: 0 0 1em 0;
					font-weight: 500;
					font-size: 0.9em;
				}

				.details {
					display: flex;
					flex-flow: row wrap;
					place-items: center;
					gap: 1em;
					border: 0.02em solid ${vars.colorPrimaryDark};
					padding: 1em;
					border-radius: ${vars.defaultRadius};
					position: relative;

					&.error {
						border: 0.15em solid ${vars.colorError};
					}

					.details-image {
						border-radius: ${vars.defaultRadius};
					}

					.image-icon {
						margin-left: auto;
					}

					.details-user {
						display: flex;
						flex-flow: column wrap;
						gap: 0.3em;
						font-size: 0.8em;

						.details-user-name {
							font-weight: 500;
						}
					}

					.cancel-icon {
						position: absolute;
						top: 0.5em;
						right: 0.5em;
						cursor: pointer;
					}
				}

				.google-error {
					color: ${vars.colorError};
					margin: 0.5em 0 0 0;
				}
			}
		}

		.token-error {
			color: ${vars.colorError};
			font-weight: 600;

			&::first-letter {
				text-transform: capitalize;
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.form {
			width: 100%;

			.form-input-row {
				max-width: 100%;
				padding: 1em;
			}

			.submit-button {
				font-size: 1.2em;
			}

			.token-error {
				font-size: 1.5em;
			}
		}
	}
`;
